// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"885b9fc3","107":"f4355cb5","437":"8a906ca9","761":"17982700"}[chunkId] + ".chunk.css";
};